import { createContext } from "react";

import { TemplateContextValue } from "./types";

export const TemplateContext = createContext<TemplateContextValue | undefined>(undefined);
TemplateContext.displayName = "TemplateContext";
